<template>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="crm-client-breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="index==levelList.length-1" class="no-redirect">
          {{item.title }}
        </span>
        <a v-else @click.prevent="handleLink(item)">{{ item.title }}</a>
      </el-breadcrumb-item>
    </el-breadcrumb>
</template>
<script>
export default {
  props: {
    levelList: {
      require: true,
      type: Array,
      // eslint-disable-next-line no-unused-expressions
      default: () => { [] }
    }
  },
  methods: {
    handleLink(item) {
      // const { path } = item
      // this.$router.push(path)
      if (item.path === '/plan') {
        this.$emit('emitPlanMgr')
      }
    }
  }
}
</script>
<style>
.el-breadcrumb{
  height: 50px;
  line-height: 30px;
  font-size: 20px;
  color: #222222;
  border-bottom: 1px solid #e1e3e6;
  box-sizing: border-box;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link{
  font-weight: 400;
}
.crm-client-breadcrumb .el-breadcrumb__item{
  height: 100%;
  padding-right: 10px;
  padding-top: 10px;
  position: relative;
}
.crm-client-breadcrumb .el-breadcrumb__item::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #337eff;
  position: absolute;
  bottom: -1px;
  left: 0;
}
</style>
